import { memo } from 'react';

import { MegaphoneIcon } from '@air/design-icons';
import { AlertBanner } from '@air/primitive-alert-banner';

import { ALERT_BANNER_MAINTENANCE_MODE } from '~/constants/localStorageKeys';
import { MAINTENANCE_MODE_BANNER_MESSAGE } from '~/constants/testIDs';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';

export const MaintenanceModeBanner = memo(() => {
  const { maintenanceModeJson } = useFeatureFlags();

  // biome-ignore lint/suspicious/noUnnecessaryConditions: PLA-1724 — pre-existing debt, not introduced by the icon migration
  if (!maintenanceModeJson?.bannerMessage) {
    return null;
  }

  return (
    <AlertBanner
      data-testid={MAINTENANCE_MODE_BANNER_MESSAGE}
      dismissDays={1}
      id={ALERT_BANNER_MAINTENANCE_MODE}
      prefix={<MegaphoneIcon size="sm" />}
    >
      {maintenanceModeJson.bannerMessage}
    </AlertBanner>
  );
});

MaintenanceModeBanner.displayName = 'MaintenanceModeBanner';
